(document.querySelectorAll('.cupholders input[type="radio"]').forEach(function (item) {
  item.addEventListener('change', function () {
    document.getElementById('selected-cupholder').innerHTML = this.value;
  });
}),
  document.querySelectorAll('.product-form__input input[type="radio"][name="Color"]').forEach(function (item) {
    item.addEventListener('change', function () {
      const selectedValue = this.value,
        formLabel = this.closest('.product-form__input').querySelector('.form__label #selected-color');
      formLabel && (formLabel.innerHTML = selectedValue);
    });
  }),
  document.querySelectorAll('.addon-product-wrapper input[type="radio"]').forEach(function (item) {
    item.addEventListener('change', function () {
      item.closest('.product-form__input').querySelector('.selected-value').innerHTML = this.value;
    });
  }),
  document.addEventListener('DOMContentLoaded', function () {
    var tabs = document.querySelectorAll('.status-tabs.mobile .tab'),
      contents = document.querySelectorAll('.tab-content');
    function hideAllContents() {
      (contents.forEach(function (content) {
        content.style.display = 'none';
      }),
        tabs.forEach(function (tab) {
          tab.classList.remove('active');
        }));
    }
    function showAllContents() {
      (contents.forEach(function (content) {
        content.style.display = 'block';
      }),
        tabs.forEach(function (tab) {
          tab.classList.add('active');
        }));
    }
    function showContent(targetId) {
      var targetContent = document.getElementById(targetId);
      document.getElementById(targetId + '-tab-mobile')?.classList.add('active');
    }
    function handleTabClick(event) {
      (hideAllContents(),
        showContent(event.currentTarget.getAttribute('data-target')),
        tabs.forEach(function (tab) {
          tab.classList.remove('active');
        }),
        event.currentTarget.classList.add('active'));
    }
    function handleResize() {
      if (window.innerWidth < 990) {
        var activeTab = document.querySelector('.status-tabs.mobile .tab.active');
        (hideAllContents(), showContent(activeTab ? activeTab.getAttribute('data-target') : 'main-product'));
      } else showAllContents();
    }
    (handleResize(),
      tabs.forEach(function (tab) {
        tab.addEventListener('click', handleTabClick);
      }),
      window.addEventListener('resize', handleResize));
  }),
  document.addEventListener('DOMContentLoaded', function () {
    const elements = {
      announcementBar: document.getElementById('announcement-bar-with-slider'),
      mediaGallery: document.querySelectorAll('media-gallery.product__media-gallery'),
      sliderComponent: document.querySelectorAll('slider-component.main-slider'),
      productMedia: document.querySelectorAll('.product__media.media.media--transparent'),
      productMediaList: document.querySelectorAll('.product--thumbnail .product__media-list'),
    };
    if (
      elements.announcementBar &&
      Object.values(elements)
        .filter((el) => el instanceof NodeList)
        .every((nodeList) => nodeList.length > 0)
    ) {
      const adjustMainChildElementHeights = () => {
        const newMaxHeight = `calc(100vh - ${elements.announcementBar.offsetHeight}px)`;
        Object.keys(elements).forEach((key) => {
          key !== 'announcementBar' &&
            elements[key].forEach((element) => {
              (element.style.setProperty('max-height', newMaxHeight, 'important'), key === 'mediaGallery');
            });
        });
      };
      (adjustMainChildElementHeights(),
        new MutationObserver(adjustMainChildElementHeights).observe(elements.announcementBar, {
          attributes: !0,
          childList: !0,
          subtree: !0,
        }));
    } else
      console.error(
        'Some elements were not found or are empty:',
        Object.keys(elements).filter((key) => !elements[key] || elements[key].length === 0),
      );
  }),
  document.addEventListener('DOMContentLoaded', function () {
    let customChatElement = document.querySelector('inbox-online-store-chat'),
      shopifyChat = document.querySelector('#ShopifyChat'),
      chatAppDiv = document.querySelector('.chat-app'),
      closeChatButton = getCloseButton();
    function getCloseButton() {
      return customChatElement && customChatElement.shadowRoot
        ? customChatElement.shadowRoot.querySelector('[name="closeChat"]')
          ? customChatElement.shadowRoot.querySelector('[name="closeChat"]')
          : customChatElement.shadowRoot.querySelector('.chat-app--close-button')
        : document.querySelector('[name="closeChat"]');
    }
    function getToggleButton() {
      return customChatElement && customChatElement.shadowRoot
        ? customChatElement.shadowRoot.querySelector('button.chat-toggle')
        : customChatElement.querySelector('button.chat-toggle');
    }
    function handleCloseButton() {
      ((closeChatButton = getCloseButton()),
        closeChatButton &&
          closeChatButton.addEventListener('click', function () {
            shopifyChat.classList.remove('fixed-bottom');
            const toggleButton = getToggleButton();
            toggleButton &&
              toggleButton.addEventListener('click', function () {
                (shopifyChat.classList.add('fixed-bottom'), handleCloseButton());
              });
          }));
    }
    function handleChatPosition() {
      ((customChatElement = document.querySelector('inbox-online-store-chat')),
        (shopifyChat = document.querySelector('#ShopifyChat')));
      const toggleButton = getToggleButton();
      (shopifyChat &&
        (chatAppDiv && !toggleButton && (shopifyChat.classList.add('fixed-bottom'), handleCloseButton()),
        toggleButton &&
          toggleButton.addEventListener('click', function () {
            (shopifyChat.classList.add('fixed-bottom'), handleCloseButton());
          })),
        customChatElement &&
          customChatElement.shadowRoot &&
          observer.observe(customChatElement.shadowRoot, {
            childList: !0,
            subtree: !0,
          }));
    }
    const observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          node.id === 'ShopifyChat'
            ? ((shopifyChat = node), handleChatPosition())
            : node.classList &&
              node.classList.contains('chat-app') &&
              ((chatAppDiv = node), handleCloseButton(), handleChatPosition());
        });
      });
    });
    (observer.observe(document.body, { childList: !0, subtree: !0 }),
      (shopifyChat || chatAppDiv) && handleChatPosition());
  }));
//# sourceMappingURL=/s/files/1/0636/0265/5480/t/58/assets/configurator-product.js.map?v=1732991879
